import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { MessageRetailerOrBrandButton } from "../../shared/instantAnswerUtils";
import { countryToISO } from "../../utils/countryToISO";
import { getShipFromCountryForOrder } from "../../utils/getShipFromCountryForOrder";
import { getShipFromCountryForBrand } from "../../utils/getShippingFromCountryForBrand";
import { isSWFAvailableInCountry } from "../../utils/isSWFAvailableInCountry";
export var HowShippingWorks = function HowShippingWorks(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: [ShippingContextDataFn]
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var _getShipFromCountryFo;
  var shipFromCountry = (_getShipFromCountryFo = getShipFromCountryForOrder(context)) !== null && _getShipFromCountryFo !== void 0 ? _getShipFromCountryFo : getShipFromCountryForBrand(context.brand);
  var shipFromCountryISO = countryToISO(shipFromCountry);
  return isSWFAvailableInCountry(shipFromCountryISO) ? SwfAvailableScenario(strictLocalize) : SwfNotAvailableScenario(strictLocalize);
};
var SwfAvailableScenario = function SwfAvailableScenario(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_OPTIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE(strictLocalize), OLD_SHIP_WITH_FAIRE_DEFINITION(strictLocalize), OLD_SHIP_ON_YOUR_OWN_DEFINITION(strictLocalize)];
    }
  };
};
var SwfNotAvailableScenario = function SwfNotAvailableScenario(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_OPTIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_CAN_USE_YOUR_OWN_CARRIER(strictLocalize)];
    }
  };
};
var SHIPPING_OPTIONS = function SHIPPING_OPTIONS(strictLocalize) {
  return strictLocalize({
    id: "UGEH5X",
    defaultMessage: [{
      "type": 0,
      "value": "Options d'expédition"
    }]
  });
};
var OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE = function OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE(strictLocalize) {
  return strictLocalize({
    id: "cITe5h",
    defaultMessage: [{
      "type": 0,
      "value": "Une fois votre commande prête à expédier, vous pouvez choisir Expédier avec Faire ou Expédier par vous-même."
    }]
  });
};
var YOU_CAN_USE_YOUR_OWN_CARRIER = function YOU_CAN_USE_YOUR_OWN_CARRIER(strictLocalize) {
  return strictLocalize({
    id: "ctr/F1",
    defaultMessage: [{
      "type": 0,
      "value": "Lorsque la commande est prête à être expédiée, vous pouvez faire appel à votre propre transporteur pour l'expédition. Il suffit d'entrer le coût de l'expédition et le numéro de suivi dans notre système lorsque vous les connaîtrez. Nous vous rembourserons les frais d'expédition avec le versement pour votre commande."
    }]
  });
};
var OLD_SHIP_WITH_FAIRE_DEFINITION = function OLD_SHIP_WITH_FAIRE_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "pgJwpA",
    defaultMessage: [{
      "type": 0,
      "value": "Grâce à l'option Expédier avec Faire, vous imprimez vos étiquettes d'expédition sur la plateforme et vous bénéficiez de tarifs réduits chez les transporteurs, sans payer de frais d'expédition. Pour vous faire gagner du temps, nous enregistrons automatiquement le montant des frais d'expédition et le numéro de suivi du colis !"
    }]
  });
};
var OLD_SHIP_ON_YOUR_OWN_DEFINITION = function OLD_SHIP_ON_YOUR_OWN_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "FAgUqw",
    defaultMessage: [{
      "type": 0,
      "value": "Choisissez Expédier par vous-même si vous souhaitez vous charger de l'expédition. Vous pouvez faire appel à votre propre transporteur pour expédier cette commande. Il suffit d'entrer le coût de l'expédition et le numéro de suivi dans notre système lorsque vous les connaîtrez, et nous vous rembourserons les frais d'expédition avec le paiement de votre commande."
    }]
  });
};